import CachedIcon from "@mui/icons-material/Cached";
import CloseIcon from "@mui/icons-material/Close";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { v4 as uuid4 } from "uuid";
import { getSitesAndFloorsData } from "../../../global/utility/Utils";
import "./common.scss";

export const CustomButton = ({ resourceObject, handleFilterChange }) => {
  return (
    <div className="entire-button-filter-spread">
      <div>{resourceObject?.displayName}</div>
      <div
        className="filter-spread-button"
        onClick={() => {
          handleFilterChange(
            resourceObject?.tab,
            resourceObject?.option,
            "filter-spread"
          );
        }}
      >
        <CloseIcon />
      </div>
    </div>
  );
};

const FilterSpreadContainer = ({
  callfilterEventApi,
  filters,
  handleFilterChange,
}) => {
  const { lastUpdated } = useSelector(
    (state) => state?.availableIncidentsReducer
  );
  const { Events, Severity, Status, Companion, Location } = useSelector(
    (state) => state.eventSettingsReducer
  );
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  
  // Helper function to get location names
  const getLocationDisplayName = (location) => {
    if (!location || !location.siteid) return "";
    
    const locationData = getSitesAndFloorsData(siteTagList);
    const site = siteTagList?.sites?.find(s => s.id === location.siteid);
    const floor = siteTagList?.floors?.find(f => f.id === location.floorid);
    const area = locationData?.areas?.find(a => a.id === location.areaid);
    
    let displayName = site?.name || `Site: ${location.siteid}`;
    if (location.floorid && floor?.name) {
      displayName += `, ${floor.name}`;
    } else if (location.floorid) {
      displayName += `, Floor: ${location.floorid}`;
    }
    if (location.areaid && area?.name) {
      displayName += `, ${area.name}`;
    } else if (location.areaid) {
      displayName += `, Area: ${location.areaid}`;
    }
    
    return displayName;
  };
  
  return (
    <div className="filter-spread-container">
      <div className="filter-spread-viewing-section-container">
        {(Companion?.length > 0) || (Events?.length > 0) || (Severity?.length > 0) || (Status?.length > 0) || (Location?.length > 0) ? <div>Viewing:</div> : null}
        <div className="filter-spread-button-section">
          {Companion &&
            Array.isArray(Companion) &&
            Companion.map((item) => {
              return (
                <div key={uuid4()}>
                  <CustomButton
                    resourceObject={{
                      tab: "Companion",
                      option:
                        (filters &&
                          filters?.Companion?.find((i) => i?.value === item)) ??
                        {},
                      displayName:
                        (filters &&
                          filters?.Companion &&
                          filters?.Companion?.find((i) => i?.value === item)
                            ?.name) ??
                        "",
                    }}
                    handleFilterChange={handleFilterChange}
                  />
                </div>
              );
            })}
          {Events &&
            Array.isArray(Events) &&
            Events.map((item) => {
              return (
                <div key={uuid4()}>
                  <CustomButton
                    resourceObject={{
                      tab: "Events",
                      option:
                        (filters &&
                          filters?.Events?.find((i) => i?.value === item)) ??
                        {},
                      displayName:
                        (filters &&
                          filters?.Events &&
                          filters?.Events?.find((i) => i?.value === item)
                            ?.name) ??
                        "",
                    }}
                    handleFilterChange={handleFilterChange}
                  />
                </div>
              );
            })}
          {Severity &&
            Array.isArray(Severity) &&
            Severity.map((item) => {
              return (
                <div key={uuid4()}>
                  <CustomButton
                    resourceObject={{
                      tab: "Severity",
                      option:
                        (filters &&
                          filters?.Severity?.find((i) => i?.value === item)) ??
                        {},
                      displayName:
                        (filters &&
                          filters?.Severity &&
                          filters?.Severity?.find((i) => i?.value === item)
                            ?.name) ??
                        "",
                    }}
                    handleFilterChange={handleFilterChange}
                  />
                </div>
              );
            })}
          {Status &&
            Array.isArray(Status) &&
            Status.map((item) => {
              return (
                <div key={uuid4()}>
                  <CustomButton
                    resourceObject={{
                      tab: "Status",
                      option:
                        (filters &&
                          filters?.Status?.find((i) => i?.value === item)) ??
                        {},
                      displayName:
                        (filters &&
                          filters?.Status &&
                          filters?.Status?.find((i) => i?.value === item)
                            ?.name) ??
                        "",
                    }}
                    handleFilterChange={handleFilterChange}
                  />
                </div>
              );
            })}
          {Location && Location?.siteid && (
            <div key={Location?.siteid}>
              <CustomButton
                resourceObject={{
                  tab: "Location",
                  option: { value: "clear_location" },
                  displayName: getLocationDisplayName(Location),
                }}
                handleFilterChange={handleFilterChange}
              />
            </div>
          )}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        <div>Last Updated</div>
        <div>{lastUpdated}</div>
        <Tooltip title="Refresh events">
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              callfilterEventApi(1);
            }}
          >
            <CachedIcon />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default FilterSpreadContainer;
